module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-0.473c9caf.png";